export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfCxc4AMP6lbBP.7cfed753.woff2";